<template>
  <div class="terms-container">
    <div class="terms-head">
      <div class="head-inner">
        <h1>Үйлчилгээний нөхцөл</h1>
        <p class="subtitle">www.imj.mn цахим хуудасны үйлчилгээний нөхцөл</p>
      </div>
    </div>

    <div class="terms-card">
      <section v-for="(section, index) in sections" :key="index">
        <h2>{{ section.title }}</h2>
        <p v-for="(item, idx) in section.items" :key="idx">
          {{ idx + 1 }}. {{ item.text }}
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import terms from "../data/terms.js";

export default {
  data() {
    return {
      sections: terms,
    };
  },
};
</script>

<style scoped>
.terms-container {
  font-family: "Roboto", sans-serif;
  color: #11181c;
  line-height: 1.65;
  padding-bottom: 60px;
  background: #f8fafc;
}
.terms-head {
  background: linear-gradient(135deg, #22b353, #1a8f42);
  color: #ffffff;
  padding: 40px 20px 44px;
}
.head-inner {
  max-width: 760px;
  margin: 0 auto;
}
h1 {
  margin: 0 0 4px;
  font-size: 1.75em;
}
.subtitle {
  margin: 0;
  opacity: 0.92;
  font-size: 0.94em;
}
.terms-card {
  max-width: 760px;
  margin: -20px auto 0;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 32px 28px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}
section {
  margin-bottom: 28px;
}
section:last-child {
  margin-bottom: 0;
}
h2 {
  font-size: 1.12em;
  margin: 0 0 10px;
  color: #22b353;
}
p {
  margin: 0 0 12px;
  color: #475569;
}
@media screen and (max-width: 600px) {
  .terms-card {
    margin: -20px 12px 0;
    padding: 24px 18px;
  }
}
</style>
